import React, { PropsWithChildren, useContext } from "react";
import cn from "classnames";
import { TriggerCollapseIcon } from "../icons/triggerCollapse";
import { TriggerCollapseDarkIcon } from "../icons/triggerCollapseDark";
import { themeContext } from "../../lib";
import styles from "./collapsible-panel.module.scss";

interface PanelProps extends PropsWithChildren {
    className?: string;
    collapsed: boolean;
    showCollapseBtn?: boolean;
    onCollapseChange: () => void
}

export const CollapsiblePanel: React.FC<PanelProps> = React.memo(({
                                                                      children,
                                                                      className,
                                                                      collapsed,
                                                                      showCollapseBtn = true,
                                                                      onCollapseChange
                                                                  }) => {
    const [theme] = useContext(themeContext);
    const onCollapseButtonClick = () => {
        onCollapseChange();
    }

    return <div className={cn(styles.panel, className, collapsed ? styles.collapsed : "")}>
        <div className={cn(styles.childWrapper, collapsed ? styles.contentCollapsed : "")}>{children}</div>
        {showCollapseBtn && <div onClick={onCollapseButtonClick} className={styles.collapseButton}>
            {theme === "light" ? <TriggerCollapseIcon/> : <TriggerCollapseDarkIcon/>}
        </div>}
    </div>
});
